import React, { useMemo } from "react";
import { useCountdown } from "../hooks/useCountdown";
import { getLaunchTarget } from "../utils/launchDate";
export function Countdown() {
  const target = useMemo(() => getLaunchTarget(), []);
  const {
    days,
    hours,
    minutes,
    seconds,
    isComplete
  } = useCountdown(target);
  const units = [{
    label: "Days",
    value: days
  }, {
    label: "Hours",
    value: hours
  }, {
    label: "Minutes",
    value: minutes
  }, {
    label: "Seconds",
    value: seconds
  }];
  return <div data-id="element-14" data-mp="3h0pevetphjuj">
      <div role="timer" aria-label={`${days} days, ${hours} hours, ${minutes} minutes and ${seconds} seconds until launch`} className="grid max-w-[580px] grid-cols-4 gap-2.5 sm:gap-4" data-id="element-15" data-mp="3h1id1reln112">
        {units.map(unit => <div key={unit.label} aria-hidden="true" className="flex aspect-[1.1] flex-col items-center justify-center rounded-md border border-brand-red/40 bg-brand-charcoal/75 backdrop-blur-sm" data-id="element-16" data-mp="3731heh4pty8o">
            <span className="font-display font-expanded text-[26px] font-semibold leading-none tabular-nums text-brand-white sm:text-4xl lg:text-[44px]" data-id="element-17" data-mp="y0wr1bdwlefq">
              {String(unit.value).padStart(2, "0")}
            </span>
            <span className="mt-2 text-[9px] font-semibold uppercase tracking-[0.16em] text-brand-white/85 sm:mt-3 sm:text-xs" data-id="element-18" data-mp="17pya5afqwbxx">
              {unit.label}
            </span>
          </div>)}
      </div>
      {isComplete && <p className="mt-3 text-sm text-brand-white/80" data-id="element-19" data-mp="f2kjtv6jyems">Launching now — check back shortly.</p>}
    </div>;
}